/* import __COLOCATED_TEMPLATE__ from './help-dialog.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type HelpTextService from '../../services/help-text';
import type IntlService from 'ember-intl/services/intl';

interface HelpDialogArgs {
  item: { isFromUrl: boolean; url: string; title: string; message: string };
  close: () => void;
}

export default class HelpDialog extends Component<HelpDialogArgs> {
  @service('help-text') declare helptext: HelpTextService;
  @service declare intl: IntlService;
  @service('aditools-site') declare siteconfig: { [key: string]: string };
  @tracked helptextContent: string | null = null;
  @tracked isLoading = false;
  private loadedUrl: string | undefined;

  get shouldLoadContent(): boolean {
    if (this.args.item?.isFromUrl && this.args.item.url !== this.loadedUrl) {
      void this.fetchContent(this.args.item.url);
    }
    return this.args.item?.isFromUrl ?? false;
  }

  private async fetchContent(url: string): Promise<void> {
    console.log('fetching....');
    this.loadedUrl = url;
    this.isLoading = true;
    this.helptextContent = null;
    try {
      const raw = await this.helptext.helpText(url);
      const keyParms: Record<string, string | number | boolean> = {
        htmlSafe: true,
      };
      if (raw.indexOf('{siteurl}') > -1) {
        keyParms['siteurl'] = this.siteconfig['SiteUrl'] + '/' + this.siteconfig['AdiLocale'];
      }
      this.helptextContent = this.intl.formatMessage(this.helptext.toICUMessage(raw), keyParms);
    } catch (error) {
      this.helptextContent = null;
      console.error(`Failed to fetch helptext from ${url}:`, error);
    } finally {
      this.isLoading = false;
    }
  }
}
